// Main Chilean banks with their standard CMF/SBIF transfer codes (the value
// stored in BankAccount.bankCode). Curated to the institutions an org is
// likely to use; extend as needed. `code` is what the payout pipeline expects.
export const CHILEAN_BANKS = [
  { code: '001', name: 'Banco de Chile / Edwards' },
  { code: '009', name: 'Banco Internacional' },
  { code: '012', name: 'BancoEstado' },
  { code: '014', name: 'Scotiabank Chile' },
  { code: '016', name: 'Banco de Crédito e Inversiones (BCI)' },
  { code: '027', name: 'Banco Itaú Corpbanca' },
  { code: '028', name: 'Banco BICE' },
  { code: '031', name: 'HSBC Bank Chile' },
  { code: '037', name: 'Banco Santander Chile' },
  { code: '039', name: 'Banco Itaú Chile' },
  { code: '049', name: 'Banco Security' },
  { code: '051', name: 'Banco Falabella' },
  { code: '053', name: 'Banco Ripley' },
  { code: '055', name: 'Banco Consorcio' },
  { code: '672', name: 'Coopeuch' },
];

export const ACCOUNT_TYPES = [
  { value: 'corriente', label: 'Cuenta corriente' },
  { value: 'vista', label: 'Cuenta vista' },
  { value: 'ahorro', label: 'Cuenta de ahorro' },
];

export function bankName(code) {
  return CHILEAN_BANKS.find((b) => b.code === code)?.name ?? code ?? '—';
}

export function accountTypeLabel(value) {
  return ACCOUNT_TYPES.find((t) => t.value === value)?.label ?? value ?? '—';
}
